import { default as SanityBlockContent } from "@sanity/block-content-to-react";
import React, { ReactNode } from "react";
import { blockId, linkFragmentFromText } from "../../utils/blocks";
import Text, { TextVariant } from "../Text/Text";

const DefaultBlockSerializer =
  SanityBlockContent.defaultSerializers.types.block;

interface BlockContentBlockProps {
  bodyVariant: TextVariant;
  node: any;
  children: ReactNode;
}

const BlockContentBlock = ({
  bodyVariant,
  ...props
}: BlockContentBlockProps) => {
  const { node, children } = props;
  const blockStyle = node.style || "normal";
  switch (blockStyle) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
      return (
        <Text
          id={linkFragmentFromText(node)}
          variant={blockStyle}
          // We add this so we can easily write CSS for spacing.
          className={blockStyle}
        >
          {children}
        </Text>
      );
    // This can be removed once the translated content has been fixed.
    // See https://github.com/microbit-foundation/sanity-crowdin-bridge/issues/38
    case "undefined":
    case "normal":
      return (
        <Text id={blockId(node)} variant={bodyVariant} as="p">
          {children}
        </Text>
      );
    case "normalCentered":
      return (
        <Text
          id={blockId(node)}
          className={blockStyle}
          variant={bodyVariant}
          as="p"
        >
          {children}
        </Text>
      );
    case "light":
      return (
        <Text id={blockId(node)} variant="defaultLight">
          {children}
        </Text>
      );
    case "subtitle":
      return (
        <Text id={blockId(node)} className={blockStyle} variant={blockStyle}>
          {children}
        </Text>
      );
    default:
      return <DefaultBlockSerializer {...props} />;
  }
};

export default BlockContentBlock;
